export const GROWTH_PUBLISH_CHANNEL_KEYS = [
  'web-blog',
  'web-landing',
  'resources-pdf',
  'storefront-pdp',
  'storefront-plp',
  'telegram',
  'bale',
  'instagram',
  'email',
  'sms',
  'web',
  'social-organic'
] as const;

export const GROWTH_ARTICLE_OPTIONAL_PUBLISH_CHANNELS = ['telegram', 'bale', 'email', 'sms'] as const;

export const GROWTH_MARKETING_CHANNEL_KEYS = [
  'email',
  'sms',
  'push',
  'in-app',
  'whatsapp',
  'telegram',
  'bale',
  'web',
  'social',
  'landing',
  'resources'
] as const;

export type GrowthMarketingChannelKey = (typeof GROWTH_MARKETING_CHANNEL_KEYS)[number];

export const GROWTH_SOCIAL_NETWORK_KEYS = ['instagram', 'linkedin', 'x', 'facebook', 'telegram', 'bale'] as const;

export function buildGrowthPublishChannelOptions(
  translate: (key: string) => string
): Array<{ label: string; value: string }> {
  return GROWTH_PUBLISH_CHANNEL_KEYS.map(value => ({
    value,
    label: translate(`growth.publish.channels.${value}`)
  }));
}

export function buildGrowthArticleOptionalPublishChannelOptions(
  translate: (key: string) => string
): Array<{ label: string; value: string }> {
  return GROWTH_ARTICLE_OPTIONAL_PUBLISH_CHANNELS.map(value => ({
    value,
    label: translate(`growth.publish.channels.${value}`)
  }));
}

export function buildGrowthMarketingChannelOptions(
  translate: (key: string) => string
): Array<{ label: string; value: GrowthMarketingChannelKey }> {
  return GROWTH_MARKETING_CHANNEL_KEYS.map(value => ({
    value,
    label: translate(`growth.channels.${value}`)
  }));
}

export function buildGrowthSocialNetworkOptions(
  translate: (key: string) => string
): Array<{ label: string; value: string }> {
  return GROWTH_SOCIAL_NETWORK_KEYS.map(value => ({
    value,
    label: translate(`growth.social.network.${value}`)
  }));
}

export function isGrowthPublicWebPublishChannel(channelKey: string): boolean {
  const key = channelKey.trim().toLowerCase();
  return key === 'web-blog' || key === 'web-landing' || key === 'web' || key === 'resources-pdf';
}

export function isGrowthStorefrontApplyChannel(channelKey: string): boolean {
  const key = channelKey.trim().toLowerCase();
  return key.startsWith('storefront') || key === 'marketplace-pdp' || key === 'marketplace-plp';
}

export function growthPublishChannelLabel(channelKey: string, translate: (key: string) => string): string {
  const labelKey = `growth.publish.channels.${channelKey}`;
  const translated = translate(labelKey);
  return translated === labelKey ? channelKey : translated;
}

export const GROWTH_STOREFRONT_APPLY_TARGET_TYPES = [
  'storefront-pdp',
  'storefront-plp',
  'storefront',
  'marketplace-pdp',
  'marketplace-plp'
] as const;

export function buildGrowthStorefrontApplyTargetOptions(
  translate: (key: string) => string
): Array<{ label: string; value: string }> {
  return GROWTH_STOREFRONT_APPLY_TARGET_TYPES.map(value => ({
    value,
    label: growthPublishChannelLabel(value, translate)
  }));
}

export const GROWTH_CONTENT_PILLAR_KEYS = [
  'awareness',
  'consideration',
  'conversion',
  'retention',
  'advocacy',
  'education'
] as const;

export function buildGrowthContentPillarOptions(
  translate: (key: string) => string
): Array<{ label: string; value: string }> {
  return GROWTH_CONTENT_PILLAR_KEYS.map(value => ({
    value,
    label: translate(`growth.strategy.pillars.${value}`)
  }));
}
